module.exports = __webpack_public_path__ + "static/khachanov-profile-16abc6c7604d39327e02d6fd983b92eb.jpg";